define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/middleware/customView/customViewValidateService",
	"csi/prefs",
	"csi/util",
	"csi/xml"
], function(declare, _, Controller, {writeMigrationKeyReportOperations}, prefs, util, xml) {

	return declare(Controller, {
		/**
		 * @override
		 * Ensure that all results are loaded on page
		 */
		onPreActionDeferreds: function(dfds) {
			dfds.push(this.widget.queryMoreToTarget(true));
		},

		process: function() {
			// summary: output XML script of all errors
			var view = this.widget;
			var w = this.m_writer;
			var query;

			// first, delete all orphans
			var orphans = _.keys(view._mapOrphans);
			if (orphans.length) {
				w.addComment("Delete Orphan / Outdated Views");
				w.deleteList(orphans, null, null, true);
				w.flushChanges();
			}

			// second, output ops to resolve moved custom views
			var moves = _.values(view._mapMoves);
			if (moves.length) {
				w.addComment("Delete Moved Views");
				w.deleteList(moves, null, null, true);
				w.flushChanges();
			}

			// third, output ops to remove nested view errors
			w.addComment("Resolve Nested Views");

			_.each(view._mapNested, function(nestedViewKeys, keyView) {
				query = w.createQuery();
				query.And()
					.Node(xml.PROP_TYPE, xml.OP_EQUALS, prefs.TYPE_VIEW)
					.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, prefs.URL_PREFIX + keyView);

				w.changeQuery(query).removeAttributeKeys("NestedViews", xml.ATTR_REFMAP, _.keys(nestedViewKeys));
				w.flushChanges();
			});

			// last, output ops to remove keys with errors
			_.each(_.keys(view._mapKeyReports).sort(), (targetClass) => {
				const report = view._mapKeyReports[targetClass];
				writeMigrationKeyReportOperations(w, targetClass, report, true);
			});

			var win = open("", "Custom View Pre-Migration");
			if (win) {
				win.document.write("<HTML><HEAD><TITLE>Custom View Pre-Migration</TITLE></HEAD>");
				win.document.write("<BODY><pre>" + util.xmlToString(util.serializeXML(w.doc)) + "</pre></BODY></HTML>");
				win.document.close();
			}

			view.resetMigration();
			this.postProcess();
		}
	});
});